import './_3d-app.scss';
import {useEffect, useRef} from "react";
import puzzles from "../../utils/puzzles";
import VStore from "../../store";
const V3DApp = () => {

    const data = [
        { hour: '1a.m', uv: 400},
        { hour: '2a.m', uv: 300},
        // ...
    ];

    const {isMobile, setIsLoading, setCurrentMode, setCurrentFloor} = VStore();

    const iframeRef = useRef(null);

    useEffect(() => {
        window.addEventListener('message', function (e) {
            if (e.data === 'v3d_loaded') {
                //@ts-ignore
                puzzles.setProcedures(iframeRef.current.contentWindow.v3d.puzzles.procedures);
                setIsLoading(false);
                //@ts-ignore
                iframeRef.current.focus();
            } else if (e.data.type === 'update_camera') {
                const camAttributes = e.data['cam'];
                puzzles.mapProcedures?.updatePlayer(camAttributes);
            } else if (e.data.type === 'update_mode') {
                const mode = e.data['mode'];
                setCurrentMode(mode);
            } else if (e.data.type === 'update_floor') {
                setCurrentFloor(e.data['floor']);
            }
        })

    }, []);

    return <div className='v3d-viewer'>

        {
            isMobile ?
                <iframe src="./assets/3dmodel/v3d_mobile"
                        title='3d-viewer'
                        ref={iframeRef}></iframe>
                :
                <iframe src="./assets/3dmodel/v3d"
                        title='3d-viewer'
                        ref={iframeRef}></iframe>
        }

        {/*<div className='annotation-container'>
            <div id='anno_box' className='annotation electrical-box'>
                415.0 V
                <br/>
                5.0000 A
                <br/>
                1.0000 PF
                <br/>
                17854212 kWh
            </div>
            <div id='anno_hvac_1' className='annotation hvac temperature'>60&deg;C</div>
            <div id='anno_hvac_2' className='annotation hvac temperature'>80&deg;C</div>
            <div id='anno_hvac_3' className='annotation hvac temperature'>80&deg;C</div>
        </div>*/}

    </div>
}

export default V3DApp;
